import {
  type AvailabilityRequest,
  AvailabilityRequestEnum,
  type AvailabilityResponse,
  AvailabilitySort,
  type SearchPageToken,
} from "@b2bportal/rbc-activities-api";
import { activitiesApi } from "@overrides/utilities";
import dayjs from "dayjs";
import type { ActivitySearchDetails } from "../../types";

export const fetchActivitiesAvailability = async (
  searchDetails: ActivitySearchDetails
): Promise<AvailabilityResponse> => {
  const request: AvailabilityRequest = {
    AvailabilityRequest: AvailabilityRequestEnum.InitialSearch,
    pageSize: 50, // Default page size
    selection: searchDetails.place.id,
    dateRange: {
      from: dayjs(searchDetails.dateRange.from).format("YYYY-MM-DD"),
      until: dayjs(searchDetails.dateRange.until).format("YYYY-MM-DD"),
    },
    refinement: {
      duration: [],
      startTime: [],
      tags: [],
      rating: {
        minTripadvisorRating: 3.5, // Default rating
      },
      ...searchDetails.refinement,
      sort: searchDetails.sort ?? AvailabilitySort.Recommended, // Default sort
    },
  };

  try {
    const response =
      await activitiesApi.apiV0ActivitiesAvailabilityPost(request);

    return response.data;
  } catch (error) {
    const errorMessage = error instanceof Error ? error.message : String(error);
    throw new Error(`Failed to fetch activities availability: ${errorMessage}`);
  }
};

/**
 * Fetches the next page of activities results
 */
export const fetchActivitiesAvailabilityNextPage = async (
  nextPageToken: SearchPageToken
): Promise<AvailabilityResponse> => {
  try {
    const request: AvailabilityRequest = {
      AvailabilityRequest: AvailabilityRequestEnum.FollowupSearch,
      nextPageToken,
    };

    const response =
      await activitiesApi.apiV0ActivitiesAvailabilityPost(request);

    return response.data;
  } catch (error) {
    const errorMessage = error instanceof Error ? error.message : String(error);
    throw new Error(`Failed to fetch more activities: ${errorMessage}`);
  }
};
